import React from 'react'
import FitToPageButton from './FitToPageButton'

/**
 * Graphics Element Properties Component
 * Handles the properties panel for graphic and svg-graphic elements
 */
const GraphicsElementProperties = ({
  element,
  selectedElement,
  updateElementProperty,
  currentPage
}) => {
  if (element.type !== 'graphic' && element.type !== 'svg-graphic') {
    return null
  }

  return (
    <div className="flex items-center space-x-4 flex-wrap gap-y-2">
      {/* Width */}
      <div className="flex items-center space-x-2">
        <label className="text-sm text-gray-600">Width:</label>
        <input
          type="number"
          value={element.width || 100}
          onChange={(e) => updateElementProperty(selectedElement, 'width', parseInt(e.target.value))}
          className="border border-gray-300 rounded px-3 py-1.5 text-sm w-20 focus:outline-none focus:ring-2 focus:ring-blue-500"
          min="10"
          max="2000"
        />
      </div>

      {/* Height */}
      <div className="flex items-center space-x-2">
        <label className="text-sm text-gray-600">Height:</label>
        <input
          type="number"
          value={element.height || 100}
          onChange={(e) => updateElementProperty(selectedElement, 'height', parseInt(e.target.value))}
          className="border border-gray-300 rounded px-3 py-1.5 text-sm w-20 focus:outline-none focus:ring-2 focus:ring-blue-500"
          min="10"
          max="2000"
        />
      </div>

      {/* Fill Color */}
      <div className="flex items-center space-x-2">
        <label className="text-sm text-gray-600">Fill:</label>
        <input
          type="color"
          value={element.fill || '#3B82F6'}
          onChange={(e) => updateElementProperty(selectedElement, 'fill', e.target.value)}
          className="w-8 h-8 border border-gray-300 rounded cursor-pointer"
        />
        <button
          onClick={() => updateElementProperty(selectedElement, 'fill', 'transparent')}
          className="px-2 py-1 text-xs border border-gray-300 rounded hover:bg-gray-50"
        >
          Clear
        </button>
      </div>

      {/* Stroke Color */}
      <div className="flex items-center space-x-2">
        <label className="text-sm text-gray-600">Stroke:</label>
        <input
          type="color"
          value={element.stroke || '#1E40AF'}
          onChange={(e) => updateElementProperty(selectedElement, 'stroke', e.target.value)}
          className="w-8 h-8 border border-gray-300 rounded cursor-pointer"
        />
        <button
          onClick={() => updateElementProperty(selectedElement, 'stroke', 'none')}
          className="px-2 py-1 text-xs border border-gray-300 rounded hover:bg-gray-50"
        >
          None
        </button>
      </div>

      {/* Stroke Width */}
      <div className="flex items-center space-x-2">
        <label className="text-sm text-gray-600">Width:</label>
        <input
          type="number"
          value={element.strokeWidth || 1}
          onChange={(e) => updateElementProperty(selectedElement, 'strokeWidth', parseInt(e.target.value))}
          className="border border-gray-300 rounded px-3 py-1.5 text-sm w-16 focus:outline-none focus:ring-2 focus:ring-blue-500"
          min="0"
          max="20"
        />
      </div>

      {/* Opacity */}
      <div className="flex items-center space-x-2">
        <label className="text-sm text-gray-600">Opacity:</label>
        <input
          type="range"
          value={element.opacity || 1}
          onChange={(e) => updateElementProperty(selectedElement, 'opacity', parseFloat(e.target.value))}
          className="w-20"
          min="0"
          max="1"
          step="0.1"
        />
        <span className="text-sm text-gray-500 w-8">{Math.round((element.opacity || 1) * 100)}%</span>
      </div>

      {/* Shadow */}
      <div className="flex items-center space-x-2">
        <label className="text-sm text-gray-600">Shadow:</label>
        <input
          type="checkbox"
          checked={!!element.filter && element.filter.includes('drop-shadow')}
          onChange={(e) => updateElementProperty(selectedElement, 'filter', e.target.checked ? 'drop-shadow(2px 2px 4px rgba(0,0,0,0.3))' : 'none')}
          className="w-4 h-4"
        />
      </div>

      {/* Background Color */}
      <div className="flex items-center space-x-2">
        <label className="text-sm text-gray-600">Background:</label>
        <input
          type="color"
          value={element.backgroundColor || '#ffffff'}
          onChange={(e) => updateElementProperty(selectedElement, 'backgroundColor', e.target.value)}
          className="w-8 h-8 border border-gray-300 rounded cursor-pointer"
        />
        <button
          onClick={() => updateElementProperty(selectedElement, 'backgroundColor', 'transparent')}
          className="px-2 py-1 text-xs border border-gray-300 rounded hover:bg-gray-50"
        >
          Clear
        </button>
      </div>

      {/* Border Radius */}
      <div className="flex items-center space-x-2">
        <label className="text-sm text-gray-600">Radius:</label>
        <input
          type="number"
          value={element.borderRadius || 0}
          onChange={(e) => updateElementProperty(selectedElement, 'borderRadius', parseInt(e.target.value))}
          className="border border-gray-300 rounded px-3 py-1.5 text-sm w-16 focus:outline-none focus:ring-2 focus:ring-blue-500"
          min="0"
          max="50"
        />
      </div>

      {/* Rotation */}
      <div className="flex items-center space-x-2">
        <label className="text-sm text-gray-600">Rotate:</label>
        <input
          type="number"
          value={element.rotation || 0}
          onChange={(e) => updateElementProperty(selectedElement, 'rotation', parseInt(e.target.value))}
          className="border border-gray-300 rounded px-3 py-1.5 text-sm w-16 focus:outline-none focus:ring-2 focus:ring-blue-500"
          min="-360"
          max="360"
        />
        <span className="text-sm text-gray-500">°</span>
      </div>

      {/* Fit to Page Button */}
      <div className="mt-4">
        <FitToPageButton
          selectedElement={selectedElement}
          updateElementProperty={updateElementProperty}
          currentPage={currentPage}
          element={element}
        />
      </div>
    </div>
  )
}

export default GraphicsElementProperties
